export const reservationMessages = {
  cs: {
    "reservation.service": "Služba",
    "reservation.staff": "Zaměstnanec",
    "reservation.resource": "Zdroj",
    "reservation.date": "Termín",
    "reservation.contact": "Kontakt",
    "reservation.provider": "Poskytovatel",
    "reservation.facility": "Zázemí",
    "reservation.price": "Cena",
    "reservation.priceFrom": "od {price}",
    "reservation.priceOnRequest": "Cena dle domluvy",
    "reservation.duration": "{minutes} min",
    "reservation.progress": "Postup rezervace",
    "reservation.step": "Krok {number}: {label}",
    "reservation.chooseService": "Vyberte službu",
    "reservation.chooseStaff": "Vyberte zaměstnance",
    "reservation.chooseResource": "Vyberte zdroj",
    "reservation.chooseDate": "Vyberte termín",
    "reservation.yourDetails": "Vaše údaje",
    "reservation.back": "Zpět",
    "reservation.backToPortal": "Zpět na portál",
    "reservation.backToOverview": "Zpět na přehled",
    "reservation.searchServices": "Hledat služby",
    "reservation.searchStaff": "Hledat zaměstnance",
    "reservation.searchResources": "Hledat zdroje",
    "reservation.clearSearch": "Zrušit hledání",
    "reservation.unavailable": "Dočasně nedostupné",
    "reservation.resourceUnavailable": "Vybraný zdroj už není dostupný. Vyberte prosím jinou službu.",
    "reservation.noMatchingServices": "Hledání neodpovídá žádná služba.",
    "reservation.noServices": "Žádná služba zatím není dostupná.",
    "reservation.noMatchingResources": "Hledání neodpovídá žádný zdroj.",
    "reservation.noResources": "Žádný zdroj zatím není dostupný.",
    "reservation.calendar.date": "Výběr data",
    "reservation.calendar.time": "Výběr času",
    "reservation.calendar.previousMonth": "Předchozí měsíc",
    "reservation.calendar.nextMonth": "Další měsíc",
    "reservation.calendar.loading": "Načítání časů…",
    "reservation.calendar.empty": "Žádné volné časy. Zkuste jiný den.",
    "reservation.timezone": "Časové pásmo: {timezone}",
    "reservation.retry": "Zkusit znovu",
    "reservation.continue": "Pokračovat",
    "reservation.haveAccount": "Máte již účet?",
    "reservation.signIn": "Přihlásit se",
    "reservation.fields.name": "Jméno a příjmení",
    "reservation.fields.email": "E-mail",
    "reservation.fields.phone": "Telefon",
    "reservation.fields.notes": "Poznámka",
    "reservation.fields.optional": "(nepovinné)",
    "reservation.contactHint": "Kontaktní údaje předáme poskytovateli kvůli vaší rezervaci.",
    "reservation.submitting": "Rezervuji…",
    "reservation.confirm": "Potvrdit rezervaci",
    "reservation.success.title": "Rezervace byla vytvořena",
    "reservation.success.pending": "Termín čeká na potvrzení poskytovatelem.",
    "reservation.success.description": "Podrobnosti své rezervace najdete níže.",
    "reservation.myBookings": "Moje rezervace",
    "reservation.access.title": "Rezervovat službu",
    "reservation.access.membership": "Váš přístup zatím neumožňuje rezervaci. Zkontrolujte stav členství nebo kontaktujte poskytovatele.",
    "reservation.access.signIn": "Pro rezervaci této služby se přihlaste do klientského portálu.",
    "reservation.access.unavailable": "Online rezervace zde momentálně nejsou dostupné. Kontaktujte prosím poskytovatele.",
    "reservation.access.check": "Zkontrolovat přístup",
    "reservation.errors.slotsAccess": "Přístup k rezervaci se změnil. Obnovte prosím stránku.",
    "reservation.errors.slots": "Volné termíny se nepodařilo načíst.",
    "reservation.errors.slotUnavailable": "Vybraný termín už není dostupný. Vyberte prosím jiný čas.",
    "reservation.errors.retryAfter": "Další rezervaci můžete odeslat za {seconds} s.",
    "reservation.errors.rateLimit": "Odeslali jste příliš mnoho požadavků. Zkuste to prosím za chvíli.",
    "reservation.errors.access": "Přístup k rezervaci se změnil. Obnovte prosím stránku a přihlaste se, pokud je to potřeba.",
    "reservation.errors.validation": "Zkontrolujte kontaktní údaje a vybraný termín.",
    "reservation.errors.create": "Rezervaci se nepodařilo vytvořit. Zkuste to prosím znovu.",
    "reservation.errors.failed": "Rezervaci se nepodařilo vytvořit.",
    "reservation.summary.label": "Souhrn rezervace",
    "reservation.summary.title": "Souhrn",
    "reservation.summary.change": "Změnit",
    "reservation.summary.changeProvider": "Změnit poskytovatele",
    "reservation.summary.changeFacility": "Změnit zázemí",
    "reservation.summary.total": "Celkem",
    "reservation.summary.empty": "Vyberte službu pro svou rezervaci.",
  },
  en: {
    "reservation.service": "Service",
    "reservation.staff": "Staff member",
    "reservation.resource": "Resource",
    "reservation.date": "Date and time",
    "reservation.contact": "Contact",
    "reservation.provider": "Provider",
    "reservation.facility": "Facility",
    "reservation.price": "Price",
    "reservation.priceFrom": "from {price}",
    "reservation.priceOnRequest": "Price on request",
    "reservation.duration": "{minutes} min",
    "reservation.progress": "Booking progress",
    "reservation.step": "Step {number}: {label}",
    "reservation.chooseService": "Choose a service",
    "reservation.chooseStaff": "Choose a staff member",
    "reservation.chooseResource": "Choose a resource",
    "reservation.chooseDate": "Choose a date and time",
    "reservation.yourDetails": "Your details",
    "reservation.back": "Back",
    "reservation.backToPortal": "Back to portal",
    "reservation.backToOverview": "Back to overview",
    "reservation.searchServices": "Search services",
    "reservation.searchStaff": "Search staff",
    "reservation.searchResources": "Search resources",
    "reservation.clearSearch": "Clear search",
    "reservation.unavailable": "Temporarily unavailable",
    "reservation.resourceUnavailable": "The selected resource is no longer available. Please choose another service.",
    "reservation.noMatchingServices": "No services match your search.",
    "reservation.noServices": "No services are available yet.",
    "reservation.noMatchingResources": "No resources match your search.",
    "reservation.noResources": "No resources are available yet.",
    "reservation.calendar.date": "Choose a date",
    "reservation.calendar.time": "Choose a time",
    "reservation.calendar.previousMonth": "Previous month",
    "reservation.calendar.nextMonth": "Next month",
    "reservation.calendar.loading": "Loading available times…",
    "reservation.calendar.empty": "No available times. Try another day.",
    "reservation.timezone": "Time zone: {timezone}",
    "reservation.retry": "Try again",
    "reservation.continue": "Continue",
    "reservation.haveAccount": "Already have an account?",
    "reservation.signIn": "Sign in",
    "reservation.fields.name": "Full name",
    "reservation.fields.email": "Email",
    "reservation.fields.phone": "Phone",
    "reservation.fields.notes": "Note",
    "reservation.fields.optional": "(optional)",
    "reservation.contactHint": "Your contact details will be shared with the provider for your booking.",
    "reservation.submitting": "Booking…",
    "reservation.confirm": "Confirm booking",
    "reservation.success.title": "Booking created",
    "reservation.success.pending": "Your booking is awaiting confirmation from the provider.",
    "reservation.success.description": "Your booking details are shown below.",
    "reservation.myBookings": "My bookings",
    "reservation.access.title": "Book a service",
    "reservation.access.membership": "Your current access does not allow bookings. Check your membership or contact the provider.",
    "reservation.access.signIn": "Sign in to the client portal to book this service.",
    "reservation.access.unavailable": "Online booking is currently unavailable. Please contact the provider.",
    "reservation.access.check": "Check access",
    "reservation.errors.slotsAccess": "Your booking access has changed. Please refresh the page.",
    "reservation.errors.slots": "Unable to load available times.",
    "reservation.errors.slotUnavailable": "The selected time is no longer available. Please choose another time.",
    "reservation.errors.retryAfter": "You can submit another booking in {seconds} seconds.",
    "reservation.errors.rateLimit": "You have sent too many requests. Please try again shortly.",
    "reservation.errors.access": "Your booking access has changed. Please refresh the page and sign in if needed.",
    "reservation.errors.validation": "Check your contact details and selected time.",
    "reservation.errors.create": "Unable to create your booking. Please try again.",
    "reservation.errors.failed": "Unable to create your booking.",
    "reservation.summary.label": "Booking summary",
    "reservation.summary.title": "Summary",
    "reservation.summary.change": "Change",
    "reservation.summary.changeProvider": "Change provider",
    "reservation.summary.changeFacility": "Change facility",
    "reservation.summary.total": "Total",
    "reservation.summary.empty": "Choose a service for your booking.",
  },
} as const;
